import { useTranslation } from 'react-i18next';
import { Button } from '../../../components/ui/Button';
import { Icon } from '../../../components/icons';
import { cn } from '../../../lib/utils';

export type MatchQuizFooterNavProps = {
  onBack: () => void;
  backDisabled?: boolean;
  onPrimary: () => void;
  primaryLabel: string;
  primaryDisabled?: boolean;
  isPrimaryLoading?: boolean;
  className?: string;
  /** For scroll-into-view / e2e (stable id on the primary action button). */
  primaryButtonId?: string;
};

export function MatchQuizFooterNav({
  onBack,
  backDisabled = false,
  onPrimary,
  primaryLabel,
  primaryDisabled = false,
  isPrimaryLoading = false,
  className,
  primaryButtonId,
}: MatchQuizFooterNavProps) {
  const { t } = useTranslation('matching');
  return (
    <div
      className={cn(
        'sticky bottom-0 z-10 -mx-4 flex flex-wrap items-center justify-between gap-3 border-t border-border bg-background/95 px-4 py-4 backdrop-blur supports-[backdrop-filter]:bg-background/80 sm:-mx-6 sm:px-6',
        className,
      )}
    >
      <Button
        type='button'
        variant='outlineHighlight'
        size='sm'
        onClick={onBack}
        disabled={backDisabled}
        className='gap-2 font-semibold disabled:cursor-not-allowed'
      >
        <Icon name='chevron-left' className='size-4' />
        {t('quiz.back')}
      </Button>
      <Button
        type='button'
        variant='primary'
        id={primaryButtonId}
        onClick={onPrimary}
        disabled={primaryDisabled || isPrimaryLoading}
        isLoading={isPrimaryLoading}
        className='min-h-11 min-w-[10rem]'
      >
        {primaryLabel}
      </Button>
    </div>
  );
}
